module.exports = __webpack_public_path__ + "img/scan-sample.c09910.png";